/*
  ============================================================
  ASSET FILE: after-trump-kit.js

  HOW TO USE:
  1. In Shopify Admin → Online Store → Themes → Edit Code
  2. Under "Assets", click "Add a new asset"
  3. Choose "Create a blank file", name it "after-trump-kit.js"
  4. Paste this file's contents in and Save
  ============================================================
*/

(function () {
  'use strict';

  // ── QUANTITY SELECTOR ──
  var qty = 1;

  window.atkChangeQty = function (delta) {
    qty = Math.max(1, qty + delta);
    var display = document.getElementById('atk-qty');
    var input = document.getElementById('atk-qty-input');
    if (display) display.textContent = qty;
    if (input) input.value = qty;
  };

  // ── COUNTDOWN TIMER ──
  // 2028 Presidential Election: November 7, 2028
  var electionDate = new Date('November 7, 2028 00:00:00').getTime();

  function animateFlip(el, newVal, padLength) {
    if (!el) return;
    var formatted = String(newVal).padStart(padLength, '0');
    if (el.textContent !== formatted) {
      el.classList.add('atk-flip');
      setTimeout(function () {
        el.textContent = formatted;
        el.classList.remove('atk-flip');
      }, 150);
    }
  }

  function updateCountdown() {
    var now = new Date().getTime();
    var diff = electionDate - now;

    var daysEl    = document.getElementById('atk-cd-days');
    var hoursEl   = document.getElementById('atk-cd-hours');
    var minutesEl = document.getElementById('atk-cd-minutes');
    var secondsEl = document.getElementById('atk-cd-seconds');

    if (!daysEl) return; // countdown not on page

    if (diff <= 0) {
      daysEl.textContent    = '000';
      hoursEl.textContent   = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return;
    }

    var days    = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    animateFlip(daysEl,    days,    3);
    animateFlip(hoursEl,   hours,   2);
    animateFlip(minutesEl, minutes, 2);
    animateFlip(secondsEl, seconds, 2);
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

  // ── CONFETTI PARTICLES ──
  var confettiContainer = document.getElementById('atk-confetti');
  if (confettiContainer) {
    var colors = ['#C9A84C', '#E8C96A', '#F5E6B8', '#fff', '#ff6b6b', '#4ecdc4'];
    for (var i = 0; i < 30; i++) {
      var piece = document.createElement('div');
      piece.className = 'atk-confetti-piece';
      piece.style.cssText = [
        'left:' + (Math.random() * 100) + '%',
        'background:' + colors[Math.floor(Math.random() * colors.length)],
        'width:' + (3 + Math.random() * 7) + 'px',
        'height:' + (3 + Math.random() * 7) + 'px',
        'border-radius:' + (Math.random() > 0.5 ? '50%' : '0'),
        'animation-delay:' + (Math.random() * 3) + 's',
        'animation-duration:' + (2 + Math.random() * 3) + 's'
      ].join(';');
      confettiContainer.appendChild(piece);
    }
  }

  // ── ATC BUTTON FEEDBACK ──
  // Shopify's native cart AJAX handles form submission.
  // This adds a visual "Added!" confirmation on the button.
  var form = document.getElementById('atk-product-form');
  if (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.atk-atc-btn');
      if (!btn) return;
      var original = btn.textContent;
      btn.textContent = '✓ Added!';
      btn.style.background = '#4CAF50';
      btn.disabled = true;
      setTimeout(function () {
        btn.textContent = original;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    });
  }

})();